import { QueryClient } from "@tanstack/react-query";

// Shared with the QueryClientProvider in index.js so that the plain async
// loaders in this folder can hit the same cache the components do. Two screens
// asking for the same booking a navigation apart, or the same effect running
// twice under StrictMode, then costs one request instead of two.
const queryClient = new QueryClient();

export default queryClient;
